// frontend/src/app/pdf-corpus/ports/pdf-corpus.port.ts
import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  PdfDocument,
  BatchUploadEvent,
  ExtractionState,
  ExtractionStatusDto,
  PaperMetadata,
} from '../domain/types';

export interface PdfCorpusPort {
  uploadAll(groupId: number, files: File[]): Observable<BatchUploadEvent>;
  listForGroup(groupId: number): Observable<PdfDocument[]>;
  fetchOne(groupId: number, pdfId: number): Observable<PdfDocument>;
  fetchBytes(groupId: number, pdfId: number): Observable<Blob>;

  /**
   * Returns the latest extraction job. Resolves to { kind: 'NONE' } when the
   * backend responds 404 (no job exists yet); all other errors propagate.
   */
  fetchExtractionState(groupId: number, pdfId: number): Observable<ExtractionState>;

  /**
   * Triggers or re-runs extraction. Returns the freshly-reset job
   * (status='PENDING', attempts=0). The async server-side work continues; the
   * caller is expected to poll fetchExtractionState until terminal.
   */
  triggerExtraction(groupId: number, pdfId: number): Observable<ExtractionStatusDto>;

  /**
   * Reads a Paper by id within the calling group.
   */
  fetchPaper(groupId: number, paperId: number): Observable<PaperMetadata>;

  /**
   * Downloads and persists the paper's open-access PDF on the backend (idempotent), returning
   * the id of the stored PDF document. Use when a paper has no pdfId yet but has a remote link.
   */
  materializePdf(groupId: number, paperId: number): Observable<number>;
}

export const PDF_CORPUS_PORT = new InjectionToken<PdfCorpusPort>('PDF_CORPUS_PORT');
